import { Injectable } from '@angular/core';
import { Helpers } from '../helpers/index';
import { environment } from 'src/environments/environment';

@Injectable()
export class KeycloakConfig {
    /**
     * Set Base Keycloak Url
     */
    public static _baseUrl = "https://auth.guglielmo.biz/";

    /**
     * Keycloak realm configuration
     * @_authUrl    = general url to keycloak console
     * @_realm      = name of realm in keycloak
     * @_clientId   = name of client id based in keycloak
     * @param path_to_redir = path to login keycloak page
     */
    public static _authUrl = "https://auth.guglielmo.biz/auth/";
    public static _realm = "IoTDevicesManagement";
    public static _clientId = "iotdevicesmanagement-dashboard-public";

    /****************** DA SOSTITUIRE IN PROD  */
    // public static path_to_redir = `${environment.baseDashboard}/devices`; // PROD
    public static path_to_redir = `${environment.baseDashboard}`; // PROD
    // public static path_to_redir = "http://localhost:4200/devices"; // DEV local

    /**
     * Generate log out
     * redirect keycloak
     */
    public static keycloakLogout(): void {
        // console.log(document.cookie);
        const randomParam = `?${Math.random()}`;
        const currentUrl = window.location.href;
        window.location.href = currentUrl + randomParam;


        const currentUser = Helpers.getCurrentUser();
        const encode_path = encodeURI(this.path_to_redir);
        Helpers.clearStorage();

        window.location.href = `https://auth.guglielmo.biz/auth/realms/${this._realm}/protocol/openid-connect/logout?client_id=${this._clientId}&post_logout_redirect_uri=${encode_path}&id_token_hint=${currentUser.idToken}`;
    }

    public static clearCache() {
        const randomParam = `?${Math.random()}`;
        const currentUrl = window.location.href;
        window.location.href = currentUrl + randomParam;
      }
}